import MenuNames from "../../../constants/Menu/MenuNames.json";
import BlinkitOnboarding from "../../../views/BlinkitOnboarding";

const BlinkitOnboardingRoutes = [
  {
    menuName: MenuNames.SLOT_CAPACITY_UPDATE,
    path: "/blinkit-onboarding-upload",
    component: BlinkitOnboarding,
    exact: true,
  },
];

export default BlinkitOnboardingRoutes;
